import { IEntity, IPagedSearchParams } from '@pf/shared-common';
import {
    Currency,
    InventoryBundleFragment,
    ItemFragment,
    PurchaseOrderHeaderFragment,
    PurchaseOrderLineFragment,
    ReceiptHeaderFragment,
    ReceiptLineSearchRequestParams,
    ReceiptLineViewModelCreateBody,
    ReceiptLineViewModelRead,
    ReceiptStatus,
} from '@control-tower/platform-wms';
import { CustomFieldDto } from '@pf/shared/util-platform';

export type ReceiptLineRead = ReceiptLineViewModelRead & IEntity;
export type ReceiptLineCreate = ReceiptLineViewModelCreateBody;
export type ReceiptLineSearchParams = ReceiptLineSearchRequestParams & {
    receiptId?: string | null;
} & IPagedSearchParams;

export class ReceiptLineDto implements IEntity {
    constructor(data: Partial<ReceiptLineDto>) {
        Object.assign(this, data);
    }
    id!: string;
    status!: ReceiptStatus;
    inventoryReceiptId!: string;
    isDeleted?: boolean;
    createdDate?: string;
    modifiedDate?: string;
    costPerUnit?: Currency;
    vendorLPN?: string | null;
    itemSerialNumber?: string | null;
    modifiedByUser?: string | null;
    actualQuantity?: number;
    expectedQuantity?: number;
    damagedQuantity?: number;
    isReceived?: boolean | null;
    lineNumber?: number | null;
    externalReferenceId?: string | null;
    inventoryReceipt?: ReceiptHeaderFragment;
    item?: ItemFragment;
    receivedBundle?: InventoryBundleFragment;
    purchaseOrderHeader?: PurchaseOrderHeaderFragment;
    purchaseOrderLine?: PurchaseOrderLineFragment;
    customFields?: Array<CustomFieldDto> | null;
    advanceShippingNoticeId?: string | null;
    advanceShippingNoticeLineId?: string | null;
}
